import { type TFunction } from "i18next";

import { SYSTEM_USER_LABEL } from "../constants";
import { PlaceholderValue } from "./PlaceholderValue";
import { type UserSummary } from "../../../types";

interface AuditCellProps {
  dateTime?: string | null;
  t: TFunction;
  user?: UserSummary | null;
}

const getFullName = (user?: UserSummary | null) => {
  const fullName = [user?.first_name, user?.last_name]
    .map(name => name?.trim())
    .filter(Boolean)
    .join(" ");

  return fullName || SYSTEM_USER_LABEL;
};

const formatDateTime = (value: string | null | undefined) => {
  if (!value) {
    return undefined;
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return undefined;
  }

  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
};

const AuditCell = ({ dateTime, t, user }: AuditCellProps) => {
  const formattedDateTime = formatDateTime(dateTime);

  if (!formattedDateTime) {
    return <PlaceholderValue />;
  }

  return (
    <div className="min-w-0 leading-tight">
      <div className="text-foreground">{formattedDateTime}</div>
      <div className="mt-1 truncate text-muted-foreground text-xs">
        {t("configuration.byFullName", { fullName: getFullName(user) })}
      </div>
    </div>
  );
};

export { AuditCell };
